import {
  PermissionValues,
  useCurrentAccount,
  useCurrentWorkspace
} from '@gripp/shared-logic';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { CurrentIssueContextProvider } from '../../issues/issueContext';
import { ActivityFilters } from './activityFilters';
import { ActivitiesProps, ActivityList } from './activityList';

export const ActivityFoldOneColumn = (props: ActivitiesProps) => {
  const workspace = useCurrentWorkspace(true);
  const { account } = useCurrentAccount();
  const isImpersonateWorkspace = useMemo(
    () =>
      workspace &&
      account &&
      account.hasPermission(PermissionValues.globalAdmin),
    [account, workspace]
  );
  
  const listMaxHeight = useMemo(
    () => isImpersonateWorkspace
      ? (props?.maxHeight ?? 0) - 50
      : props.maxHeight ?? 0,
    [isImpersonateWorkspace, props.maxHeight]
  );

  const heightStyle = useMemo(
    () => ({ maxHeight: props.maxHeight }),
    [props.maxHeight]
  );

  return (
    <CurrentIssueContextProvider>
      {
        !props.hideFilterBar && (
          <View style={styles.filtersContainer}>
            <ActivityFilters assetId={props.assetId} />
          </View>
        )
      }
      <View style={[styles.container, heightStyle]}>
        <View style={styles.listContainer}>
          <ActivityList
            listMaxHeight={listMaxHeight}
            onDataLoaded={props.onDataLoaded}
            {...props}
          />
        </View>
      </View>
    </CurrentIssueContextProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  filtersContainer: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  listContainer: {
    width: '100%',
    overflow: 'hidden',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    paddingBottom: 8,
  },
  gutter: {
    width: 24,
  },
});
